<template>
  <component
    :is="plansLink ? 'router-link' : 'div'"
    :to="plansLink ? { name: 'FilterPage' } : undefined"
    :class="['flats-counter', { 'flats-counter--link': plansLink }]"
  >
    <div class="flats-counter__wrapper">
      <div class="flats-counter__title">
        <span class="flats-counter__count">{{ normalizeCount(count) }}</span>
        {{ normalizeTitle(count, title) }}
      </div>
      <div class="flats-counter__subtitle">
        {{ normalizeTitle(count, subtitle) }} в продаже
      </div>
    </div>
  </component>
</template>

<script>
export default {
  name: "FlatsCounter",
  props: {
    plansLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: ["лот", "лота", "лотов"],
      subtitle: ["остался", "осталось", "осталось"],
    };
  },
  methods: {
    normalizeTitle(num, dec) {
      if (num > 100) num = num % 100;
      if (num <= 20 && num >= 10) return dec[2];
      if (num > 20) num = num % 10;
      return num === 1 ? dec[0] : num > 1 && num < 5 ? dec[1] : dec[2];
    },
    normalizeCount(num) {
      return num < 10 ? `0${num}` : num;
    },
  },
  computed: {
    count() {
      return this.$store.getters.apartments.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.flats-counter {
  letter-spacing: 0.05em;
  font-weight: 350;
  padding-top: 37px;
  box-sizing: border-box;

  @media screen and (max-width: $screen-md) {
    max-width: 115px;
    max-height: 68.5px;
  }

  &--link {
    pointer-events: auto;
    cursor: pointer;
    text-decoration: none;
  }

  &__wrapper {
    padding: 0px 36px 8px 24px;
    background-color: #1e1919;

    @media screen and (max-width: $screen-md) {
      padding: 0px 21px 8px 14px;
    }
  }

  &__title {
    font-size: 20px;
    color: #ffffff;

    @media screen and (max-width: $screen-md) {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }

  &__count {
    font-size: 80px;
    font-weight: 700;
    line-height: 30px;
    color: #e14313;

    @media screen and (max-width: $screen-md) {
      font-size: 60px;
    }
  }

  &__subtitle {
    padding-top: 5px;
    font-size: 14px;
    color: #ffffffcc;

    @media screen and (max-width: $screen-md) {
      font-size: 10px;
    }
  }
}
</style>
